export default __webpack_public_path__ + "static/media/shoes8.a5ceebc8.jpeg";